import NetResourcesRepository from './NetResourcesRepository';
import NetResourcesRepositoryAdapter from './NetResourcesRepositoryAdapter';

import EpisodeMapper, {
  EpisodeData,
} from '../../data/entities/mappers/EpisodeMapper';

import Episode from '../../domain/entities/Episode';
import EpisodesRepository from '../../domain/repositories/EpisodesRepository';

export default class NetEpisodesRepository
  extends NetResourcesRepository<Episode, EpisodeData>
  implements EpisodesRepository
{
  constructor() {
    super(
      new NetResourcesRepositoryAdapter('/api/episodes', new EpisodeMapper()),
    );
  }
}
